/**
 * AccountCard
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import { useApi2fetch, useApi2update } from 'containers/Api2/useApi2.js';
import InfoButton from 'components/interaction/InfoButton/index.jsx';
import Switch from 'components/interaction/Switch/index.jsx';
import cx from 'utils/cx.js';
import messages from '../messages.js';
import ResetPasswordControl from './ResetPasswordControl.jsx';

function AccountCard(props) {
  const { user, className, selector } = props;
  const { onlyExternalLogin, externalLogins } = user;
  const hasExternal = externalLogins?.length > 0;
  const api2fetch = useApi2fetch();
  const api2update = useApi2update();

  const setExternalLogin = () => {
    if (onlyExternalLogin) {
      api2fetch({ url: 'sa/users/disableOnlyExternalLogin', method: 'POST', body: { userId: user.id, roleType: user.roleType }, version: 2 })
        .then(() => {
          api2update({ selector: `${selector}/onlyExternalLogin`, updater: () => false });
        });
    }
  };
  return (
    <Card className={cx('border-0', className)}>
      <Card.Header className="d-flex justify-content-between align-items-baseline px-0 pb-2">
        <h3 className="card-title"><FormattedMessage {...messages.account} /></h3>
      </Card.Header>
      <Card.Body className="d-flex align-items-center px-0">
        <div className="col-sm-4 pe-3">
          <ResetPasswordControl user={user} variant="light" disabled={onlyExternalLogin} />
          {onlyExternalLogin && (<InfoButton className="ps-2"><FormattedMessage {...messages.disabledSocsLogin} /></InfoButton>)}
        </div>
        <Switch disabled={!hasExternal || !onlyExternalLogin} value={!onlyExternalLogin} onChange={setExternalLogin}>
          <FormattedMessage {...messages.logInSocs} />
          {!onlyExternalLogin && (<InfoButton className="ps-2"><FormattedMessage {...messages.onlySelfDisableLogin} /></InfoButton>)}
        </Switch>
      </Card.Body>
    </Card>
  );
}

AccountCard.propTypes = {
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
  selector: PropTypes.string.isRequired,
};

export default AccountCard;
